"use client";

import Link from "@/infrastructure/router/Link";
import type { DiscoveryTrack } from "@/domain/discovery/DiscoveryRepository";
import { playbackHref } from "@/domain/discovery/DiscoveryRepository";

export function DiscoveryArtwork({
	tone,
	label,
}: Readonly<{ tone: DiscoveryTrack["artwork"]; label: string }>) {
	return (
		<span
			className={`discovery-art discovery-art--${tone}`}
			role="img"
			aria-label={`${label} 封面`}
		>
			<span aria-hidden="true">✦</span>
		</span>
	);
}

export function TrackRow({
	track,
	queue,
	index,
	onUnavailable,
}: Readonly<{
	track: DiscoveryTrack;
	queue: readonly DiscoveryTrack[];
	index: number;
	onUnavailable?: () => void;
}>) {
	const href = playbackHref(track, queue);
	const content = (
		<>
			<span className="track-row__index" aria-hidden="true">
				{String(index + 1).padStart(2, "0")}
			</span>
			<DiscoveryArtwork tone={track.artwork} label={track.title} />
			<span className="track-row__copy">
				<strong>{track.title}</strong>
				<small>
					{track.artist} · {track.genre}
				</small>
			</span>
			<span className="track-row__duration">
				{formatDuration(track.durationSeconds)}
			</span>
			<span className="track-row__play" aria-hidden="true">
				{href === null ? "锁定" : "▶"}
			</span>
		</>
	);
	if (href !== null)
		return (
			<Link
				className="track-row"
				href={href}
				aria-label={`播放 ${track.title}`}
			>
				{content}
			</Link>
		);
	return (
		<button
			className="track-row"
			type="button"
			onClick={onUnavailable}
			aria-label={`${track.title} 暂不可播放`}
		>
			{content}
		</button>
	);
}

export function formatDuration(seconds: number): string {
	if (seconds <= 0) return "—";
	return `${Math.floor(seconds / 60)}:${String(Math.floor(seconds % 60)).padStart(2, "0")}`;
}
